import React from "react";

function CountdownTimer(props) {
  const { timeLeft } = props;

  // Convert the timeLeft value to minutes and seconds
  const hours = Math.floor(timeLeft / 60000 / 60000);
  const minutes = Math.floor(timeLeft / 60000);
  const seconds = Math.floor((timeLeft % 60000) / 1000);

  return (
    <span style={{ color: `${timeLeft === 0 ? "tomato" : "#C597FB"}` }}>
      {timeLeft ? (
        <>
          {hours < 10 ? "0" : ""}
          {hours}:{minutes < 10 ? "0" : ""}
          {minutes}:{seconds < 10 ? "0" : ""}
          {seconds}
        </>
      ) : (
        <>00:00:00</>
      )}
    </span>
  );
}

export default CountdownTimer;
